var styleDataHash = "ca62434b";
const injectCss = (() => {
  var css = `.KUm8q{position:relative}.KUm8q:after{background-color:#fff;border:1px solid #dfe5eb;border-radius:10px;bottom:-12px;box-shadow:0 0 18px 0 rgba(0,6,36,.1),0 6px 6px 0 rgba(0,6,36,0);content:"";left:-12px;position:absolute;right:-12px;top:-12px;z-index:-1}.bRleK{box-shadow:none;margin-inline:-12px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var ai_widget_default = {
  "wrapper": "KUm8q",
  "promptInputArea": "bRleK"
};
export {
  ai_widget_default as default,
  injectCss
};
//# sourceMappingURL=ai-widget-scss.js.map
